import SolarArrayIcon from './SolarArrayIcon'

export default SolarArrayIcon
